import { useEffect, useState } from "react";
import { fmtDate } from "@/components/DatePicker";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PhoneInput } from "@/components/PhoneInput";
import { Contact, Save } from "lucide-react";
import { toast } from "sonner";

export function ContactSettings() {
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/site/contact").then((r) => setC(r.data)).catch(() => {}); }, []);
  const set = (k, v) => setC((x) => ({ ...x, [k]: v }));
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/site/contact", { company_name: c.company_name, phone: c.phone, email: c.email, address: c.address, hours: c.hours }); setC(data); toast.success("Contact details saved — landing page and emails updated"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!c) return null;
  return (
    <Card className="p-5 space-y-4" data-testid="contact-settings">
      <div><h2 className="font-display font-semibold text-base md:text-lg flex items-center gap-2"><Contact className="w-5 h-5 text-primary" /> Company contact details</h2><p className="text-xs text-muted-foreground mt-0.5">Shown in the landing page header, contact section and footer, and in prospect emails (confirmation, marketing).{c.updated_at && ` Last saved ${fmtDate(c.updated_at)} by ${c.updated_by}.`}</p></div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div className="space-y-1"><Label className="text-xs">Company / brand name</Label><Input data-testid="contact-company_name" value={c.company_name} onChange={(e) => set("company_name", e.target.value)} /></div>
        <div className="space-y-1"><Label className="text-xs">Phone</Label><PhoneInput data-testid="contact-phone" value={c.phone} onChange={(v) => set("phone", v)} /></div>
        <div className="space-y-1"><Label className="text-xs">Email</Label><Input data-testid="contact-email" type="email" value={c.email} onChange={(e) => set("email", e.target.value)} /></div>
        <div className="space-y-1"><Label className="text-xs">Office hours</Label><Input data-testid="contact-hours" value={c.hours} onChange={(e) => set("hours", e.target.value)} placeholder="Mon–Fri, 8:30 AM – 5:00 PM ET" /></div>
        <div className="space-y-1 sm:col-span-2"><Label className="text-xs">Address</Label><Input data-testid="contact-address" value={c.address} onChange={(e) => set("address", e.target.value)} /></div>
      </div>
      <div className="flex justify-end"><Button data-testid="contact-save" onClick={save} disabled={busy}><Save className="w-4 h-4 mr-1.5" /> {busy ? "Saving…" : "Save contact details"}</Button></div>
    </Card>
  );
}
